module.exports = __webpack_public_path__ + "assets/img/btn-view-b4ae08d3.png";